import { render, staticRenderFns } from "./TextPlafond.vue?vue&type=template&id=6a91a8e5&scoped=true"
import script from "./TextPlafond.vue?vue&type=script&lang=js"
export * from "./TextPlafond.vue?vue&type=script&lang=js"
import style0 from "./TextPlafond.vue?vue&type=style&index=0&id=6a91a8e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a91a8e5",
  null
  
)

export default component.exports